export class Relationship {
  id: number;
  contact_id: number;
  related_id: number;
  relation_id: number;
  name: string;
  role: string;
  deleting: boolean = false;
  editing: boolean = false;
  formSubmitted: boolean = false;
  formSubmitting: boolean = false;
}
